<template>
    <Content style="background:rgba(249,249,249,1);">
        <div class="bg"></div>
        <Breadcrumb separator=">">
            <BreadcrumbItem to="/">首页</BreadcrumbItem>
            <BreadcrumbItem to="/news">新闻中心</BreadcrumbItem>
            <BreadcrumbItem>新闻详情</BreadcrumbItem>
        </Breadcrumb>
        <div class="main">
            <h1>{{newLists.title}}</h1>
            <p style="margin: 20px;font-size: 20px"><span style="margin-right: 55px">{{newLists.publishTime}}</span><span v-if="newLists != ''">作者：新华日报</span></p>
            <div class="text">
                <div class="img" v-show="newLists.picUrl">
                    <img :src="newLists.picUrl" />
                </div>
                <div v-html="newLists.content" style="line-height: 1.5"></div>
<!--                <div class="nav" v-if="newLists != ''">-->
<!--                    <div class="prev">上一篇：{{newLists.title}}</div>-->
<!--                    <div class="next">下一篇：{{newLists.title}}</div>-->
<!--                </div>-->
            </div>
        </div>
    </Content>
</template>

<script>
    import util from '../../utils/util'
    import api from '../../api/api'

    export default {
        name: "newsDetail",
        data(){
            return{
                newsId:'',
                newLists:'',
            }
        },
        activated(){
            this.newsId = this.$route.params.newsId;
            this.getNewDetail();
        },
        methods:{
            getNewDetail(){
                var _this = this;
                api.newsDetail(this.newsId).then(res=>{
                    _this.newLists = res;
                }).catch(error =>{
                    this.$Message.error('详情数据获取错误')
                })
            },
        }
    }
</script>

<style lang="scss">
    .layout {
        background: #f5f7f9;
        position: relative;
        overflow: hidden;
    }

    .bg {
        width: 100%;
        height: 280px;
        background: url("../../assets/bannner3.png") no-repeat center;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
    }

    .ivu-breadcrumb {
        margin: 25px auto;
        padding-left: 18%;
        text-align: left;
        font-size:18px;
        font-family:MicrosoftYaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
    }

    .main {
        .text {
            width: 70%;
            margin: 0px auto;
            padding: 30px;
            text-align: left!important;
            .img {
                padding: 0px 40px;
                margin-bottom: 25px;
                height: 400px;
                width: 100%;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .content {
                text-indent: 2em;
                text-align: left;
                font-size:18px;
                font-family:MicrosoftYaHei;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:36px;
            }
            .nav {
                text-align: left;
                margin-top: 65px;
                font-size:18px;
                font-family:MicrosoftYaHei;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height: 40px;
                :hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
